import { FC } from "react";
import { InlineBadgeEditor, type BadgeColor } from "@rothoblaas/design-system";
import useI18n from "../../../../hooks/useTranslations";
import { CompatibilityLevel, COMPATIBILITY_LEVELS } from "../../../../http/screwConnector/types/common";

type LevelKey = "0" | "1" | "2";

const colorByLevel: Record<LevelKey, BadgeColor> = {
  "0": "grey",
  "1": "warning",
  "2": "success",
};

interface CompatibilityLevelEditorProps {
  value: CompatibilityLevel;
  onChange: (value: CompatibilityLevel) => void;
}

// compatibility_level is a small fixed ordinal (0 = not compatible, 1 = restricted, 2 = fully
// compatible), so it's rendered as a 3-way inline badge picker rather than a dropdown.
const CompatibilityLevelEditor: FC<CompatibilityLevelEditorProps> = ({ value, onChange }) => {
  const i18n = useI18n();
  const labels = i18n.translation.screwConnectorModule.compatibilityLevels;
  const labelByLevel: Record<LevelKey, string> = {
    "0": labels.notCompatible,
    "1": labels.restricted,
    "2": labels.compatible,
  };

  const options = COMPATIBILITY_LEVELS.map((level) => ({
    value: String(level) as LevelKey,
    label: labelByLevel[String(level) as LevelKey],
    color: colorByLevel[String(level) as LevelKey],
  }));

  return (
    <InlineBadgeEditor<LevelKey>
      value={String(value) as LevelKey}
      options={options}
      onChange={(next) => onChange(Number(next) as CompatibilityLevel)}
    />
  );
};

export default CompatibilityLevelEditor;
